(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trust-reviews"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.trust-slider').forEach(slider => {
    const wrapper = slider.querySelector('.trust-track-wrapper');
    const prev = slider.querySelector('.trust-prev');
    const next = slider.querySelector('.trust-next');
    const card = slider.querySelector('.trust-card');
    if (!wrapper || !prev || !next || !card) return;

    const gap = 16;
    const scrollAmount = card.offsetWidth + gap;

    prev.addEventListener('click', () => {
      wrapper.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });

    next.addEventListener('click', () => {
      wrapper.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
